import { Typography, Box } from '@mui/material';
import './project-status.scss';
import { useTitle } from '../../hooks/useTitle.ts';

export const ProjectStatusView = () => {
  useTitle('Project Status - Immersive Homes');

  return (
    <Box id="ProjectStatusPage">
      <Box className="container">
        <Box className="text">
          <Typography variant="h2" className="title">
            Home Milestones
          </Typography>
          <Typography className="description">
            Track every step of your home's design and customization process —
            from floorplan selection to finalizing the order.
          </Typography>
        </Box>
        <Box className="box-container">
          <Box className="box">
            <Typography className="step">Set Project Budget</Typography>
          </Box>
          <Box className="box">
            <Typography className="step">Select Model & Floor Plan</Typography>
          </Box>
          <Box className="box">
            <Typography className="step">Select Finishing Package</Typography>
          </Box>
          <Box className="box">
            <Typography className="step">
              Visualize & Customize in VR
            </Typography>
          </Box>
          <Box className="box">
            <Typography className="step">
              Finalize Order & Make Deposit
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="container">
        <Box className="text">
          <Typography variant="h2" className="title">
            Land Milestones
          </Typography>
          <Typography className="description">
            Monitor progress on land acquisition, zoning, surveys, and site
            preparation.
          </Typography>
        </Box>
        <Box className="box-container">
          <Box className="box">
            <Typography className="step">Select Land & Make Offer</Typography>
          </Box>
          <Box className="box">
            <Typography className="step">Authorize Land Studies</Typography>
          </Box>
          <Box className="box">
            <Typography className="step">Create Site Plan</Typography>
          </Box>
          <Box className="box">
            <Typography className="step">Close on Land</Typography>
          </Box>
          <Box className="box">
            <Typography className="step">Submit for Permitting</Typography>
          </Box>
          <Box className="box">
            <Typography className="step">Complete Site Prep</Typography>
          </Box>
        </Box>
      </Box>

      <Box className="container">
        <Box className="text">
          <Typography variant="h2" className="title">
            Construction Milestones
          </Typography>
          <Typography className="description">
            Stay in the loop on home delivery, landscaping, and on-site
            assembly.
          </Typography>
        </Box>
        <Box className="box-container">
          <Box className="box">
            <Typography className="step">
              Delivery & Assembly Complete
            </Typography>
          </Box>
          <Box className="box">
            <Typography className="step">
              Complete Interior & Landscaping
            </Typography>
          </Box>
          <Box className="box">
            <Typography className="step">
              Inspection, CO , Delivery Complete
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
